<template>
  <div
    :data-testid="`remark-group-container-${name}`"
    class="tw-bg-gray-100 tw-rounded-lg remark-group"
  >
    <div
      class="
        tw-flex
        tw-flex-row
        tw-justify-between
        tw-align-center
        tw-py-4
        tw-px-6
        tw-sticky
        tw-bg-gray-100
        tw-rounded-lg
        tw-z-40
        remark-group--header
      "
      :data-testid="`remark-group-${name}`"
    >
      <span class="tw-flex tw-flex-row tw-align-baseline">
        <i
          data-testid="remark-group-toggle"
          class="tw-text-xs tw-w-6 tw-p-1 tw-text-center tw-cursor-pointer fa"
          :class="expanded ? 'fa-chevron-down' : 'fa-chevron-right'"
          @click="toggleExpanded"
        />
        <span class="tw-text-base tw-font-medium">{{ name }}</span>
      </span>
      <span>
        <span
          class="
            tw-uppercase tw-font-medium tw-text-xs tw-text-sf-gray-dark tw-p-2
          "
        >
          <span data-testid="message-count-indicator">
            <slot name="message-count-indicator" />
          </span>
        </span>
        <SfButtonDs
          v-if="showMarkAsRead"
          size="sm"
          icon-before="envelope-open"
          data-testid="remark-group-mark-as-read"
          :disabled="disableMarkAsRead"
          :data-heap="markAsReadHeapTag"
          @click="emit('markAsRead')"
        >
          {{ I18n.t('communication.inbox.mark_as_read') }}
        </SfButtonDs>
      </span>
    </div>
    <div
      v-if="expanded"
      class="tw-flex tw-flex-col tw-gap-4"
      :class="bodyPaddingClasses"
    >
      <slot name="default" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { SfButtonDs } from '@silverfin/ui-components'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { commsTheme } from '@app/shared/comms-theme'

const emit = defineEmits<{ markAsRead: []; toggled: [boolean] }>()

interface Props {
  disableMarkAsRead?: boolean
  showMarkAsRead?: boolean
  initiallyOpened?: boolean
  markAsReadHeapTag?: string
  // The right drawer is 400px wide, so its cards get the width back that the
  // inbox can afford to spend on padding.
  tightPadding?: boolean
  name: string
}

const props = withDefaults(defineProps<Props>(), { initiallyOpened: true })

const theme = commsTheme()

const bodyPaddingClasses = computed(() =>
  props.tightPadding && theme.newLayout ? 'tw-px-2 tw-pb-2' : 'tw-px-6 tw-pb-6'
)

const expanded = ref<boolean>(props.initiallyOpened)
function toggleExpanded() {
  expanded.value = !expanded.value
  emit('toggled', expanded.value)
}

const I18n = useI18n()
</script>

<style scoped>
.remark-group--header {
  top: var(--sf-remark-group-sticky-offset);
}
</style>
